import {IGetRolesFilter} from "@models/roles/IGetRolesFilter.ts";
import {DefaultFilterPageProps} from "@models/DefaultFilterPageProps.ts";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {useState} from "react";
import {Grid, TextField} from "@mui/material";

interface RolesFiltersPageProps extends DefaultFilterPageProps<IGetRolesFilter> {

}

export function RolesFilterPage(props: RolesFiltersPageProps) {
    const [filters, setFilters] = useState<IGetRolesFilter>(props.filters ?? {});

    const handleApply = () => {
        if (props.setFilters != null)
            props.setFilters(filters)
        if (props.onApply != null)
            props.onApply()
    }

    return (<DefaultContainer hideHeader>
            <Grid spacing={1}>
                <Grid size={{sm: 12, md: 6}}>
                    <TextField value={filters.nome ?? ''}
                               onKeyDown={(e) => {
                                   if (e.key == 'Enter') {
                                       handleApply()
                                   }
                               }}
                               label={'Nome'}
                               onChange={(e) => {
                                   setFilters({...filters, nome: e.target.value})
                               }}/>
                </Grid>
                <Grid size={{sm: 12, md: 6}}>
                    <TextField value={filters.descricao ?? ''}
                               onKeyDown={(e) => {
                                   if (e.key == 'Enter') {
                                       handleApply()
                                   }
                               }}
                               label={'Descrição'}
                               onChange={(e) => {
                                   setFilters({...filters, descricao: e.target.value})
                               }}/>
                </Grid>
            </Grid>

        </DefaultContainer>
    )
}

